import axios from 'axios';
import { RequestBody } from '../utils/types';

const axiosApiCall = async (type: string, url: string, body?: RequestBody<object>) => {
  const controller = new AbortController();
  setTimeout(() => controller.abort(), 3000);
  switch (type) {
    case 'GET':
      return await axios.get(url, { timeout: 15000 * 100 }).then(t => t.data);
    case 'POST':
      return await axios.post(url, body, { timeout: 15000 * 100 }).then(t => t.data);
    case 'PUT':
      return await axios.put(url, body, { timeout: 15000 * 100 }).then(t => t.data);
  }
};

export { axiosApiCall };
